"use client";

import React from "react";
import { Linkedin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const agents = [{
  name: "Robert Miller",
  position: "Master Roofer & Founder",
  bio: "With 25 years of structural expertise, Robert oversees every project to ensure RM's signature 'Shield' standard of durability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/robert_miller_roofing_expert.png"
}, {
  name: "Marcus Chen",
  position: "Waterproofing Specialist",
  bio: "Marcus leads our technical finishing team, specializing in advanced membrane systems and industrial-grade weatherproofing.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/marcus_chen_waterproofing_specialist.png"
}];
export default function MeetYourAgents() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223174" id="the-experts-behind-the-shield" className="py-20 bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-screen-xl h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent opacity-50" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-5xl font-extrabold font-default text-primary mb-4 tracking-tighter">
            The Experts Behind the Shield
          </h2>
          <p className="text-lg font-default text-muted-foreground">
            Our skilled team is committed to delivering top-tier craftsmanship, reliability, and technical precision for every structure.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {agents.map((agent, i) => <div key={agent.name} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="group relative overflow-hidden border border-primary/10 shadow-sm hover:shadow-xl transition-all duration-300 h-full flex flex-col bg-card rounded-lg">
                <div className="aspect-[4/3] sm:aspect-square overflow-hidden relative bg-slate-900/10">
                  <img src={agent.image} alt={`Portrait of ${agent.name}`} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 ease-in-out group-hover:scale-105" />
                  <div className="absolute top-4 right-4 bg-primary text-primary-foreground px-3 py-1 rounded-full text-[10px] font-mono uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    Expert Certified
                  </div>
                </div>
                <CardHeader className="text-center relative z-10 bg-card flex-grow flex flex-col justify-center pt-6 pb-8">
                  <CardTitle className="text-xl font-extrabold font-default text-primary mb-1 tracking-tight">
                    {agent.name}
                  </CardTitle>
                  <CardDescription className="text-primary/70 font-mono text-xs uppercase tracking-wider">
                    {agent.position}
                  </CardDescription>
                </CardHeader>

                {}
                <div className="absolute inset-0 bg-primary/95 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-all duration-300 flex flex-col items-center justify-center p-8 text-center z-20">
                  <CardTitle className="text-xl font-extrabold font-default text-primary-foreground mb-2 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 ease-out">
                    {agent.name}
                  </CardTitle>
                  <CardDescription className="text-ring font-mono text-xs uppercase tracking-widest mb-4 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 ease-out delay-75">
                    {agent.position}
                  </CardDescription>
                  <p className="text-primary-foreground/80 font-default text-sm mb-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300 ease-out delay-100 leading-relaxed">
                    {agent.bio}
                  </p>
                  <div className="translate-y-4 group-hover:translate-y-0 transition-transform duration-300 ease-out delay-150">
                    <Link to="#" className="inline-flex items-center justify-center size-12 rounded-full bg-primary-foreground/10 text-primary-foreground hover:bg-ring hover:text-primary transition-colors shadow-md" aria-label={`${agent.name}'s LinkedIn profile`}>
                      <Linkedin className="size-5" />
                    </Link>
                  </div>
                </div>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}